import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import { GetAll } from "../../../../features/admin/master/permission/Slice";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/role-management/role/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import Section_title from "../../../common-components/section-title/Section_title";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";

const Add = () => {
  const permission = useSelector((state) => state.masters.permission);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = React.useState(false);
  const { id } = useParams();

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      data.permission_id = getValues("permission_id").filter(Boolean);
      let response;
      if (id) {
        response = await dispatch(Update({ id, data }));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset();

        setModalShow(true);

        setTimeout(() => {
          setModalShow(false);
          navigate("/roles");
        }, 2000);
      }
    } catch (error) {
      console.error("error in Add Namee", error);
    }
  };

  const getPermissions = async () => {
    if (id) {
      const res = await dispatch(GetAll(id));
    }
  };

  const getRole = async () => {
    if (id) {
      const res = await dispatch(GetSingle(id));
      reset(res?.payload?.data);
      await setValue(
        "permission_id",
        res?.payload?.data?.Roles_Permissions.map((val) => val?.permission_id),
      );
    }
  };

  // const selected = watch("permission_id") || [];

  console.log(getValues(), "getValues");

  useEffect(() => {
    getPermissions();
    getRole();
  }, [id]);

  const selectedPermissions = watch("permission_id") || [];

  return (
    <>
      <section className="content_body section_box">
        <div className="top_title_sec">
          <div className="forms_section">
            <div className="row align-items-end">
              <div className="col-md-12">
                <Section_title title="Role Edit" alltotal="" />
              </div>
            </div>
          </div>
        </div>
        <div className="forms_section">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                <div className="form-group">
                  <Form.Label>Role</Form.Label>
                  <Form.Control
                    type="text"
                    name=""
                    placeholder="Role"
                    {...register("name", {
                      required: "name is Required",
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.name,
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name?.message}</span>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-5">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0 fw-bold">Permissions</h6>

                <button
                  type="button"
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => {
                    const allIds = permission?.data?.map((p) => p.id) || [];

                    const isAllSelected =
                      selectedPermissions.length === allIds.length;

                    setValue("permission_id", isAllSelected ? [] : allIds);
                  }}
                >
                  {selectedPermissions.length === permission?.data?.length
                    ? "Deselect All"
                    : "Select All"}
                </button>
              </div>

              {/* Grid */}
              <div className="row">
                {permission?.data?.map((val) => (
                  <div key={val.id} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                    <label className="permission-card h-100 d-flex align-items-center gap-2 p-3 border rounded shadow-sm">
                      <input
                        type="checkbox"
                        className="form-check-input m-0"
                        checked={selectedPermissions.includes(val?.id)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          const value = val?.id;
                          const current = selectedPermissions || [];

                          setValue(
                            "permission_id",
                            checked
                              ? [...current, value]
                              : current.filter((id) => id !== value),
                          );
                        }}
                      />

                      <span className="permission-text">{val?.name}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => navigate("/roles")}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <Successfull_Modal
              message={"Successful"}
              show={modalShow}
              onHide={() => setModalShow(false)}
            />
          </Form>
        </div>
      </section>
    </>
  );
};

export default Add;
